import './styles/srolltop.css';
document.addEventListener('DOMContentLoaded', function () {
    const scrollToTopBtn = document.getElementById("scrollToTopBtn") as HTMLElement;
    if(!scrollToTopBtn){
        return;
    }
    function toggleScrollBtn() {
        if (window.scrollY > 300) {
            scrollToTopBtn.style.display = "block";
        } else {
            scrollToTopBtn.style.display = "none";
        }
    }
    // Initial check (for reloads/bookmarks)
    toggleScrollBtn();

    // On scroll
    window.addEventListener("scroll", toggleScrollBtn);

    // Scroll to top on click
    scrollToTopBtn.addEventListener("click", function () {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
});